module.exports = [{"key":"Driftsoppgave","text":"Driftsoppgave"},{"key":"Forvaltning","text":"Forvaltning"},{"key":"Fast-track","text":"Fast-track"},{"key":"Prosjekt","text":"Prosjekt"},{"key":"Oppdrag","text":"Oppdrag"},{"key":"Satt på vent","text":"Satt på vent"},{"key":"Forslag ikke videreført som egen aktivitet","text":"Forslag ikke videreført som egen aktivitet"},{"key":"Avventer beslutning IT-styre/Ledermøte","text":"Avventer beslutning IT-styre/Ledermøte"}]


//////////////////
// WEBPACK FOOTER
// ./src/constants/changes.json
// module id = 701
// module chunks = 0